// @flow
export const BLOG_ARTICLES_REQUEST = 'BLOG_ARTICLES_REQUEST';
export const BLOG_ARTICLE_REQUEST = 'BLOG_ARTICLE_REQUEST';
export const BLOG_ARTICLE_REQUESTED = 'BLOG_ARTICLE_REQUESTED';
export const BLOG_ARTICLES_REQUESTED = 'BLOG_ARTICLES_REQUESTED';
export const BLOG_CATEGORIES_REQUESTED = 'BLOG_CATEGORIES_REQUESTED';
export const BLOG_CATEGORIES_REQUEST = 'BLOG_CATEGORIES_REQUEST';
export const BLOG_ARTICLES_ERROR = 'BLOG_ARTICLES_ERROR';
export const BLOG_ARTICLE_ERROR = 'BLOG_ARTICLE_ERROR';
export const BLOG_CATEGORIES_ERROR = 'BLOG_CATEGORIES_ERROR';
export const BLOG_ARTICLES_RESET = 'BLOG_ARTICLES_RESET';
export const BLOG_TESTIMONIALS_REQUEST = 'BLOG_TESTIMONIALS_REQUEST';
export const BLOG_TESTIMONIALS_REQUESTED = 'BLOG_TESTIMONIALS_REQUESTED';
export const ITEMS_PER_PAGE = 20;
